import constants from "@/config/constants";
import translations from "@/config/translations";
import useAuthStore from "@/hooks/useAuthStore";
import useDashboardStore from "@/hooks/useDashboardStore";
import useLangStore from "@/hooks/useLangStore";
import "./styles.css";

type TyDetails = { navigate: (path: string) => void };

export default function ClientPopup({ onClose, details }: { onClose: () => void; details?: TyDetails }) {
    const { lang } = useLangStore();
    const { client, token, clearAuth } = useAuthStore();
    const { store, clearStore } = useDashboardStore();
    const t = translations[lang ?? "ar"];

    const isOwner = client?.owner?.some((s: any) => s._id === store?._id);
    const role = isOwner ? t.clientMenu.owner : t.clientMenu.staff;
    const name = client?.name ?? "—";

    const navigate = details?.navigate;

    const handleProfile = () => {
        onClose();
        navigate?.("/profile");
    };

    const handleSettings = () => {
        onClose();
        navigate?.("/settings");
    };

    const handleLogout = async () => {
        try {
            await fetch(`${constants.url}/auth/logout`, {
                method: "DELETE",
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch {
            /* logout proceeds regardless */
        }
        clearAuth();
        clearStore();
        window.location.replace("/login");
    };

    return (
        <div className="client-popup">
            <button className="client-popup-profile" onClick={handleProfile} type="button">
                <div className="client-popup-avatar">
                    {client?.picture ? (
                        <img src={client?.picture} />
                    ) : (
                        <img src="/icons/client-small-placeholder-icon.svg" alt={client?.name} width={25} height={25} />
                    )}
                </div>
                <div className="client-popup-info">
                    <p className="client-popup-name">{name}</p>
                    <p className="client-popup-role">{role}</p>
                </div>
            </button>
            <div className="client-popup-divider" />
            <div className="client-popup-actions">
                <button className="client-popup-btn" onClick={handleSettings} type="button">
                    <img src="/icons/settings-icon.svg" className="client-popup-btn-icon" alt="" />
                    <span>{t.clientMenu.settings}</span>
                </button>
                <button className="client-popup-btn client-popup-btn--logout" onClick={handleLogout} type="button">
                    <img src="/icons/logout-icon.svg" className="client-popup-btn-icon" alt="" />
                    <span>{t.clientMenu.logout}</span>
                </button>
            </div>
        </div>
    );
}
